import React from 'react';
import { Navigate } from 'react-router';
import { Route, Routes } from 'react-router-dom';

import Click2PayAdmin from '@pages/click2pay/Click2PayAdmin';
import Click2PayInfoContent from '@pages/click2pay/onboarding/Click2PayInfoContent';
import Click2PayInfoReviewPage from '@pages/click2pay/onboarding/Click2PayInfoReviewPage';
import Click2PaySummary from '@pages/click2pay/onboarding/Click2PaySummary';
import Click2PayTermsAndConditions from '@pages/click2pay/onboarding/Click2PayTermsAndConditions/Click2PayTermsAndConditions';
import Click2PayChooseCards from '@pages/click2pay/onboarding/choose-card/Click2PayChooseCards';

import routes from './routes';

const Click2PayOnboarding = () => {
    return (
        <div className="sgw-layout medium-centered-container">
            <div className="sgw-layout-item">
                <Routes>
                    <Route index element={<Navigate to={routes.onboarding} replace />} />
                    <Route path={routes.onboarding} element={<Click2PayInfoContent />} />
                    <Route path={routes.termsAndConditions} element={<Click2PayTermsAndConditions />} />
                    <Route path={routes.infoReview} element={<Click2PayInfoReviewPage />} />
                    <Route path={routes.chooseCard} element={<Click2PayChooseCards />} />
                    <Route path={routes.summary} element={<Click2PaySummary />} />
                    <Route path={routes.admin} element={<Click2PayAdmin />} />
                </Routes>
            </div>
        </div>
    );
};
export default Click2PayOnboarding;
